webpackJsonp([212839066777427],{

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(17);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _lodash = __webpack_require__(24);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _ResponsiveGrid = __webpack_require__(15);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _CardText = __webpack_require__(84);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _Contents = __webpack_require__(18);
	
	var _BlogMenu = __webpack_require__(83);
	
	var _BlogMenu2 = _interopRequireDefault(_BlogMenu);
	
	var _BlogPostExcerpt = __webpack_require__(59);
	
	var _BlogPostExcerpt2 = _interopRequireDefault(_BlogPostExcerpt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blog = function (_React$Component) {
	  _inherits(Blog, _React$Component);
	
	  function Blog() {
	    _classCallCheck(this, Blog);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Blog.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'Atrakeur-Page' },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement('meta', { charSet: 'utf-8' }),
	          _react2.default.createElement(
	            'title',
	            null,
	            'DIY, Mod\xE9lisme et Web / Blog'
	          )
	        ),
	        _react2.default.createElement(_index2.default, {
	          contentID: 'blog_title',
	          size: 'medium' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'Atrakeur-Content' },
	          _react2.default.createElement(_BlogMenu2.default, null),
	          (0, _lodash.map)(data.allContentfulBlogPost.edges, function (node, index) {
	            return _react2.default.createElement(_BlogPostExcerpt2.default, { post: node.node, inverted: index % 2 == 1, key: node.node.id });
	          })
	        )
	      )
	    );
	  };
	
	  return Blog;
	}(_react2.default.Component);
	
	exports.default = Blog;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-e9b62268c6b0a2abb13f.js